import { createFileRoute } from '@tanstack/react-router'
import { TaskEditor } from './-TaskEditor'

export const Route = createFileRoute('/settings/integrations/tasks/$id')({
  component: EditTaskPage,
})

function EditTaskPage() {
  const { id } = Route.useParams()
  // `key`: een ander record is een verse editor — geen testresultaat of plakbody van de vorige.
  return <TaskEditor key={id} id={id} />
}
